import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import BIMDigitalTwin from "./BIMDigitalTwin/BIMDigitalTwin";
import ApiAuthorizationRoutes from "./auth/ApiAuthorizationRoutes";
import { ApplicationPaths } from "./auth/ApiAuthorizationConstants";
import AuthorizeRoute from "./auth/AuthorizeRoute";

const App = (): JSX.Element => {
    // TODO Get user config
    // Modules avaiable
    // Role
    // Misc config

    return (
        <Switch>
            <Route exact path="/">
                <Redirect to="/app" />
            </Route>
            <AuthorizeRoute path="/app" component={BIMDigitalTwin} />
            <Route
                path={ApplicationPaths.ApiAuthorizationPrefix}
                component={ApiAuthorizationRoutes}
            />
            <Route path="*">{/* TODO 404 component */}</Route>
        </Switch>
    );
};

export default App;
